import React from 'react'
import { PaymentElement, AddressElement } from '@stripe/react-stripe-js'

import Box from '@mui/material/Box'

import { useBrand } from 'components/shared/SettingsProvider'

const getProfile = account => {
  if (!account) return {}

  const pp = account.paymentProfile
  if (pp && (pp.firstName || pp.lastName)) return pp

  return account.user || {}
}

const buildAddressDefaults = account => {
  const profile = getProfile(account)

  return {
    name: [profile.firstName, profile.lastName].filter(Boolean).join(' '),
    address: {
      line1: profile.streetAddress || '',
      line2: '',
      city: profile.city || '',
      state: profile.region || '',
      postal_code: profile.postalCode || '',
      country: profile.country || 'US'
    }
  }
}

const buildPaymentElementOptions = account => {
  const { name } = useBrand()

  const profile = getProfile(account)

  return {
    layout: 'tabs',
    paymentMethodOrder: ['us_bank_account', 'card'],
    business: { name },
    wallets: {
      applePay: 'never',
      googlePay: 'never'
    },
    defaultValues: {
      billingDetails: {
        name: [profile.firstName, profile.lastName].filter(Boolean).join(' '),
        email: account?.user?.email || ''
      }
    }
  }
}

const NewPaymentMethodForm = ({ account }) => (
  <Box>
    <Box mb={3}>
      <PaymentElement options={buildPaymentElementOptions(account)} />
    </Box>
    <Box>
      <AddressElement
        options={{
          mode: 'billing',
          defaultValues: buildAddressDefaults(account)
        }}
      />
    </Box>
  </Box>
)

const PaymentIntentsForm = props => {
  const { account } = props

  return <NewPaymentMethodForm account={account} />
}

export default PaymentIntentsForm
